import { useEffect, useState } from "react";
import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import { getLocationPermission } from "../../../utils/geolocation";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Sessions.module.css";

const PERMISSION_STATE = {
  granted: { label: "Allowed", tone: "green" },
  prompt: { label: "Not asked yet", tone: "gray" },
  denied: { label: "Blocked", tone: "red" },
  unsupported: { label: "Unknown", tone: "gray" },
  insecure: { label: "Not available (site is not HTTPS)", tone: "red" },
};

const GUIDES = [
  {
    id: "desktop",
    title: "Chrome or Edge (computer)",
    steps: [
      "Click the lock icon at the left of the address bar.",
      "Open Site settings.",
      "Set Location to Allow.",
      "Reload this page.",
    ],
  },
  {
    id: "android",
    title: "Android (Chrome)",
    steps: [
      "Tap ⋮ (top right) → Settings → Site settings → Location.",
      "Allow location for this site (remove it from Blocked if it is there).",
      "Turn on your phone's Location (swipe down from the top of the screen).",
      "Reload this page.",
    ],
  },
  {
    id: "ios",
    title: "iPhone (Safari)",
    steps: [
      "Open Settings → Privacy & Security → Location Services and turn it ON.",
      "In the same list, open Safari Websites and choose “While Using the App”.",
      "Back in Safari, tap aA in the address bar → Website Settings → Location → Allow.",
      "Reload this page.",
    ],
  },
  {
    id: "app",
    title: "Mobile app",
    steps: [
      "Open your phone's Settings → Apps → [the HRIS app] → Permissions.",
      "Set Location to “Allow while using the app”.",
      "Turn on your phone's Location, then reopen the app.",
    ],
  },
];

const detectGuide = () => {
  const agent = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(agent)) return "ios";
  if (/Android/i.test(agent)) return "android";
  return "desktop";
};

// How to allow location access, with the browser's current permission state.
// Used by the first-login prompt and the check-in screen.
const LocationHelp = () => {
  const [permission, setPermission] = useState(null);

  useEffect(() => {
    let active = true;
    getLocationPermission().then((state) => active && setPermission(state));
    return () => {
      active = false;
    };
  }, []);

  const state = permission && PERMISSION_STATE[permission];
  const openGuide = detectGuide();

  return (
    <div className={styles.panelStack}>
      {state && (
        <div className={ui.muted}>
          Location for this site: <Badge tone={state.tone}>{state.label}</Badge>
        </div>
      )}

      {permission === "insecure" && (
        <div className={cx(ui.alert, ui.alertDanger)}>
          Browsers only share your location on secure (https://) sites. Ask IT
          for the https link to the portal.
        </div>
      )}

      <div className={styles.helpList}>
        {GUIDES.map((guide) => (
          <details
            key={guide.id}
            className={styles.helpItem}
            open={guide.id === openGuide}
          >
            <summary>{guide.title}</summary>
            <ol>
              {guide.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </details>
        ))}
      </div>
    </div>
  );
};

export default LocationHelp;
